import styled from 'styled-components'
import { Link } from "react-router-dom";

export const Wrapper = styled.div`
    border-style: inset;
    border-color: aliceblue;
    border-radius: 10px;
    display: grid;
    width:100%;
    
    box-shadow: black 20px 7px 29px 0px;
    background-color: aliceblue;

`

export const Image = styled.img`

    width: 100%;
    max-width: 200px;
    transition: all 2s;
    object-fit: cover;
    border-radius: 40px;

    :hover {
        transform: rotateY(360deg);
        opacity: 80%;
    }

`;

export const Content = styled.div`

    display:grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 1fr;
    background-color: var(--secondaryColor);
    text-align: left;
    padding: 5px;
    font-size: large;
    font-family: 'Times New Roman', Times, serif;
`;
export const StyledLink = styled(Link)`
    text-decoration: none;
    color: black;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        cursor: pointer;
    }
`;